import DatePicker from 'react-date-picker';

import { ReactComponent as CalendarIcon } from '../../assets/images/icons/calendar.svg';
import { Container } from './styles';

interface IProps {
  name?: string;
  placeholder: string;
  value?: Date;
  onChange: React.Dispatch<React.SetStateAction<Date>>;
  minDate?: Date;
  maxDate?: Date;
  isOpen?: boolean;
  onCalendarClose?: (() => any) | undefined;
  disabled?: boolean;
  disableWeekends?: boolean;
  calendarViewMode?: 'month' | 'year' | 'decade' | 'century';
  calendarMinDetail?: 'month' | 'year' | 'decade' | 'century';
  readOnlyInput?: boolean;
}

export const StyledDateInput: React.FC<IProps> = ({
  name,
  placeholder,
  value,
  onChange,
  minDate,
  maxDate,
  isOpen,
  onCalendarClose,
  disabled,
  disableWeekends = false,
  calendarViewMode,
  calendarMinDetail,
  readOnlyInput = false,
}) => {
  return (
    <Container dateValue={value} readOnlyInput={readOnlyInput}>
      <DatePicker
        name={name}
        minDate={minDate}
        maxDate={maxDate}
        isOpen={isOpen}
        onCalendarClose={onCalendarClose}
        onChange={onChange}
        value={value}
        calendarIcon={<CalendarIcon />}
        clearIcon={null}
        locale="pt-br"
        dayPlaceholder={placeholder}
        monthPlaceholder=""
        yearPlaceholder=""
        disabled={disabled}
        tileDisabled={(d) =>
          disableWeekends && (d.date.getDay() === 0 || d.date.getDay() === 6)
        }
        format="dd/MM/yyyy"
        view={calendarViewMode}
        minDetail={calendarMinDetail}
      />
    </Container>
  );
};
